// Shared between MarketplaceConnectStep.js (writes it right before navigating
// the browser to Amazon's consent page) and AmazonOAuthCallback.js (reads it
// once Amazon redirects back) so the two never drift on the sessionStorage
// key name. sessionStorage, not localStorage: this only needs to survive one
// same-tab round trip through Amazon's consent page, and should not linger
// (or leak a stale destination) across browser sessions.
export const AMAZON_OAUTH_RETURN_HASH_KEY = 'amazon_oauth_return_hash';

// Where the callback page sends the browser back to when nothing was stored
// (e.g. the tab was closed and reopened mid-flow) -- the campaign list, the
// nearest stable screen a connected campaign is always visible from.
export const AMAZON_OAUTH_DEFAULT_RETURN_HASH = '#/campaign';

// Enough of the campaign wizard's state to reopen it where the seller left it.
// The wizard is a modal whose step lives in component state, not in the URL, so
// returning to the stashed hash alone lands on the campaign list with the
// wizard closed -- the connection is saved by then, but the seller has to find
// their way back into it. Written by the wizard just before the browser leaves
// for Amazon, read once on the way back.
//
// Deliberately only identifiers: the campaign id plus the two values that
// decide which steps the wizard shows. Nothing here is trusted as data -- the
// wizard re-selects the campaign and re-derives the step list from them.
const AMAZON_OAUTH_RESUME_KEY = 'amazon_oauth_wizard_resume';

export const stashWizardResume = (payload) => {
    try {
        sessionStorage.setItem(AMAZON_OAUTH_RESUME_KEY, JSON.stringify(payload));
    } catch (e) { /* storage disabled: the return still lands on the campaign list */ }
};

// Read-and-clear: a resume is good for exactly one return trip, so a later
// visit to the campaign list never reopens the wizard unbidden.
export const takeWizardResume = () => {
    try {
        const raw = sessionStorage.getItem(AMAZON_OAUTH_RESUME_KEY);
        sessionStorage.removeItem(AMAZON_OAUTH_RESUME_KEY);
        const parsed = raw ? JSON.parse(raw) : null;
        return parsed && parsed.campaignId ? parsed : null;
    } catch (e) {
        return null;
    }
};
